import { createArray, createCell } from 'helpers';
import * as setup from 'setup';
import Danger from './Danger';

export default class DangerAnteater extends Danger {

    textureRotation = Math.PI;

    constructor(gameState: GameState, props?: DangerProps, state?: any) {
        super(gameState, 'anteater', setup.dangers.anteater, {
            ...props,
            attackingTextures: createArray(11, i => `danger/anteater/danger-anteater-attacking-${i + 1}.png`),
            movingTextures: createArray(11, i => `danger/anteater/danger-anteater-moving-${i + 1}.png`),
        }, state);
    }

    init = () => {
        const cakeCell = createCell((setup.foods.cake.x || 0) - 2, (setup.foods.cake.y || 0) - 2);
        this.moveTo(cakeCell, 0, this.findTarget);
    }

    findTarget = () => {
        // Get closest Ant based on balance
        const dangerTargets = [
            ...this.gameState.entities.dangers.antWarriors.active,
            ...this.gameState.entities.dangers.antWorkers.active,
        ];
        const targetGroup = this.gameState.entities.ants.active.length > dangerTargets.length ? this.gameState.entities.ants.active : dangerTargets;
        this.target = this.getClosestTarget(targetGroup, this.setup.searchDistance);

        // If close enough, attack, otherwise move again
        if (this.isCloseToTarget(this.target)) {
            this.attackTarget(this.target, this.findTarget);
        } else if (this.target) {
            this.moveToTarget(this.target, this.findTarget);
        } else {
            this.wanderTo(this.cell, 0, this.findTarget);
        }
    }

}